export default "/_next/static/images/customer-support-0f83d11cdc07ef88a7183c5e61a7f932.svg";